import { passRawFromMappingKey } from './passMappingKeys'

export function countLearnedPrefills(
  passNames: string[],
  passMappings: Record<string, string>,
  learnedSuggestions: Record<string, string> | undefined,
  wpsPassLabels: string[]
): number {
  const suggestions = learnedSuggestions ?? {}
  const labelSet = new Set(wpsPassLabels.map((l) => String(l).trim()).filter(Boolean))
  return passNames.filter((key) => {
    const passRaw = passRawFromMappingKey(key)
    const learned = suggestions[key] ?? suggestions[passRaw]
    if (!learned || !labelSet.has(learned)) return false
    return passMappings[key] === learned
  }).length
}
